import Vue from "vue";
import Vuex from 'vuex';
import simulator from './simulator';
import simulatorPersonal from './simulatorPersonal';
import simulatorMipyme from './simulatorMipyme';
import simulatorPyme from './simulatorPyme';
import simulatorCar from './simulatorCar';
import home from './home'

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        simulator,
        home,
        simulatorPersonal,
        simulatorMipyme,
        simulatorPyme,
        simulatorCar
    }
})

export default store;